export default __webpack_public_path__ + "static/media/pnaacl.e2308f40.png";